import auth from './auth';
import dashboard from './dashboard';

export default [
  auth,
  dashboard,
  {
    path: '/',
    redirect: '/dashboard',
  },
];
